module.exports = __webpack_public_path__ + "img/api_keys.fee47a4b.png";